/** Helper functions to process the states of the stores, also helps to keep the stores cleaner **/
export default {
    /** ====== Engine Store ====== **/


    /** If the user is currently playing return and object with the status else null **/
    currentPlay: function(state) {
        if (!state.username)
            return null;
        else
            return state.player_info[state.user_id];
    },

    /** True if you are playing and haven't cashed out, it returns true on game_crash also, it clears until game_starting **/
    currentlyPlaying: function(state) {
        let currentPlay = this.currentPlay(state);
        return currentPlay && currentPlay.bet && !currentPlay.stopped_at;
    },



    /**
     * Returns the game payout as a percentage if game is in progress
     * if the game is not in progress returns null.
     *
     * Used by the script-controller
     *
     * If the last was time exceed the STOP_PREDICTING_LAPSE constant
     * It returns the last game tick elapsed time + the STOP_PREDICTING_LAPSE
     * This will cause the graph or others to stops if there is lag.
     * Only call this function if the game is 'IN_PROGRESS'.
     * Use it for render, strategy, etc.
     * @return {number}
     */
    getGamePayout: function(state) {
        if(!(state.game_state === 'IN_PROGRESS')) {
            return null;
        }

        let elapsed;
        if((Date.now() - state.last_game_tick) < AppConstants.Engine.STOP_PREDICTING_LAPSE) {
            elapsed = Date.now() - state.start_time;
        } else {
            elapsed = state.last_game_tick - state.start_time + AppConstants.Engine.STOP_PREDICTING_LAPSE; //+ STOP_PREDICTING_LAPSE because it looks better
        }
        let gamePayout = Clib.growthFunc(elapsed);
        console.assert(isFinite(gamePayout));
        return gamePayout;
    },

    /** True if are not playing in the current game or already cashed out */
    notPlaying: function(state) {
        let currentPlay = this.currentPlay(state);
        return !(state.game_state === 'IN_PROGRESS' && currentPlay && !currentPlay.stopped_at);
    },

    /** To Know if the user is betting **/
    isBetting : function(state) {
        if (!state.username) return false;
        if (state.next_bet_amount) return true;
        for (let i = 0 ; i < state.joined.length; ++i) {
            if (state.joined[i] == state.username)
                return true;
        }
        return false;
    },

    ///** Not playing and not betting **/
    //ableToBet: function(engine) {
    //    return this.notPlaying(engine) && !this.isBetting(engine);
    //},

    /** ====== Controls Store ====== **/


    /** Parse the bet string in bits and returns a integer **/
    parseBet: function(betStringBits) {
        // return parseInt(betStringBits.replace(/k/g, '000')) * 100;
        return parseInt(betStringBits);
    },

    /** Convert the cash out string into an integer **/
    parseCashOut: function(cashOutString) {
        let cashOut = parseFloat(cashOutString);
        cashOut = Math.round(cashOut * 100);
        return cashOut;
    },


    /** ====== Mixed ====== **/

    canUserBet: function(balanceSatoshis, betStringBits, betInvalid, autoCashOutInvalid) {
        let betAmountSatoshis = this.parseBet(betStringBits);

        if(balanceSatoshis < 100)
            return new Error('Not enough bits to play');
        if(betInvalid)
            return new Error(betInvalid);
        if(autoCashOutInvalid)
            return new Error(autoCashOutInvalid);
        if(balanceSatoshis < betAmountSatoshis)
            return new Error('Not enough bits');

        return true;
    }
};
